export interface MeasuredImage {
  width: number
  height: number
}

// Loads one image off-DOM and resolves with its intrinsic size, or undefined
// when it fails to load. Never rejects, and cannot be cancelled: callers that
// unmount before it settles should ignore the result rather than act on it.
export const measureImage = (src: string) => {
  return new Promise<MeasuredImage | undefined>((resolve) => {
    // window.Image, not the ~/components/Image component.
    const image = new window.Image()

    image.onload = () => {
      if (!image.naturalWidth || !image.naturalHeight) {
        resolve(undefined)

        return
      }

      resolve({ width: image.naturalWidth, height: image.naturalHeight })
    }

    image.onerror = () => {
      resolve(undefined)
    }

    image.src = src
  })
}
